import { ForumPost } from '../../models/ForumPost';

export const buildForumPostTitle = (post: ForumPost): string => {
  const area = post.areaText ? `（${ post.areaText }）` : '';

  return `${ post.doneeNameF || 'ドニー' }様のドナー募集${ area } | Ton Bébé`;
};

export const buildForumPostDescription = (post: ForumPost): string => {
  const parts: string[] = [];

  if (post.areaText) {
    parts.push(`エリア: ${ post.areaText }`);
  }
  if (post.bloodTypeChips.length > 0) {
    parts.push(`血液型: ${ post.bloodTypeChips.join('・') }`);
  }
  if (post.ageRangeText) {
    parts.push(`年齢: ${ post.ageRangeText }`);
  }

  const condLine = parts.length > 0 ? `${ parts.join('。') }。` : '';
  const commentSnippet = post.description ? post.description.replace(/\n/g, ' ').slice(0, 60) : '';
  const commentLine = commentSnippet ? `${ commentSnippet }。` : '';
  const closingLine = 'Ton Bébéのドナー募集掲示板で、条件に合うドナーが応募できます。';

  return `${ condLine }${ commentLine }${ closingLine }`;
};
